import React, { useEffect, useState } from "react";
import ArenaNavigator from "../components/home";
import ArenaHomeLayout from "../layouts/arena-layout";
function FallbackComponent() {
  return <ArenaHomeLayout error > 
    
  </ArenaHomeLayout>;
}


type Props = {};

const GameNavigator = (props: Props) => {
  return (
    <div>
        <ArenaNavigator />
    </div>
  );
};

export default GameNavigator;
